'use client';

import { motion } from 'framer-motion';

const particles = [
  { size: 12, x: '10%', y: '20%', delay: 0, duration: 6 },
  { size: 8, x: '85%', y: '15%', delay: 1.5, duration: 7 },
  { size: 10, x: '70%', y: '60%', delay: 0.8, duration: 8 },
  { size: 6, x: '25%', y: '75%', delay: 2, duration: 6.5 },
  { size: 14, x: '90%', y: '80%', delay: 0.3, duration: 7.5 },
  { size: 9, x: '50%', y: '10%', delay: 1, duration: 6 },
  { size: 7, x: '15%', y: '55%', delay: 1.8, duration: 7 },
  { size: 11, x: '60%', y: '85%', delay: 0.5, duration: 8 },
];

function PeanutShape({ size }) {
  return (
    <svg
      width={size}
      height={size * 1.6}
      viewBox="0 0 20 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="10" cy="9" rx="7" ry="8" fill="#D4A054" opacity="0.6" />
      <ellipse cx="10" cy="23" rx="7" ry="8" fill="#C4873B" opacity="0.5" />
      <ellipse cx="10" cy="16" rx="4" ry="3" fill="#F5E6D3" opacity="0.3" />
    </svg>
  );
}

function LeafShape({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6 6 4 12 4 16c0 2 1 4 3 5 1-3 3-5 5-7 2 2 4 4 5 7 2-1 3-3 3-5 0-4-2-10-8-14z"
        fill="#4A7C59"
        opacity="0.3"
      />
    </svg>
  );
}

export default function PeanutParticles() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {particles.map((particle, i) => (
        <motion.div
          key={i}
          className="absolute"
          style={{
            left: particle.x,
            top: particle.y,
          }}
          animate={{
            y: [0, -15, 0, 10, 0],
            x: [0, 5, -5, 3, 0],
            rotate: [0, 10, -10, 5, 0],
          }}
          transition={{
            duration: particle.duration,
            delay: particle.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          {i % 3 === 0 ? (
            <LeafShape size={particle.size} />
          ) : (
            <PeanutShape size={particle.size} />
          )}
        </motion.div>
      ))}
    </div>
  );
}
